import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=6bbca2c5&scoped=true&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/login.css?vue&type=style&index=0&id=6bbca2c5&scoped=true&lang=css&"
import style1 from "./ForgotPassword.vue?vue&type=style&index=1&id=6bbca2c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbca2c5",
  null
  
)

export default component.exports